//deps
import { useCallback, useMemo } from "react";

// internal-deps
import { RenderingDetails } from "@swiggy-private/cart-types";
import { getIsOfferPackAdded } from "@swiggy-private/cart-ui";

// hooks
import { useOfferBundleAnalytics } from "./useOfferBundleAnalytics";
import { useOfferBundle } from "./useOfferBundle";

// constants
import { VALID_RENDERING_BUTTON_TYPES } from "@cart-client/constants/index";

export interface UseOfferPackWidgetDataReturnType {
    onItemClick: (itemType: string, itemData?: RenderingDetails) => void;
    isOfferPackAdded: boolean;
    analyticsEvents: {
        impressionActiveWidget: (context: string) => void;
        impressionNudge: (context: string) => void;
        clickNudge: (context: string, value: string) => void;
    };
}

export const useOfferPackWidgetData = (renderingDetails: RenderingDetails[]): UseOfferPackWidgetDataReturnType => {
    const isOfferPackAdded = useMemo(() => getIsOfferPackAdded(renderingDetails), [renderingDetails]);

    const { onUpdateItem } = useOfferBundle();
    const { impressionActiveWidget, impressionNudge, clickNudge } = useOfferBundleAnalytics();

    const onItemClick = useCallback(
        async (itemType?: string, itemData?: RenderingDetails) => {
            if (
                (itemType === VALID_RENDERING_BUTTON_TYPES.OFFER_BUNDLE_BENEFITS ||
                    itemType === VALID_RENDERING_BUTTON_TYPES.OFFER_BUNDLE_NUDGE) &&
                itemData?.meta &&
                itemData?.type
            ) {
                await onUpdateItem(itemData.meta, itemData.type, isOfferPackAdded);
            }
        },
        [isOfferPackAdded, onUpdateItem],
    );

    return {
        onItemClick,
        isOfferPackAdded,
        analyticsEvents: {
            impressionActiveWidget,
            impressionNudge,
            clickNudge,
        },
    };
};
